var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('SearchTable',{key:_vm.reloading,ref:"table",attrs:{"header":_vm.isFilterOn('confirmed')
        ? {
            title: 'Radni nalozi',
            icon: 'work',
            class: 'md-card-header-brand',
          }
        : {
            title: 'Kalkulacije',
            icon: 'outbox',
            class: 'md-card-header-brand',
          },"queriedData":_vm.modifiedFiles,"metaData":_vm.metaData,"getItems":_vm.getOffersOrOfferGroups,"params":_vm.params,"sortBy":_vm.isFilterOn('confirmed') ? 'confirmedAt' : 'dateCreated',"newItem":_vm.newOffer,"openItem":_vm.openOfferOrOfferGroup,"templates":_vm.templates,"forEachSelected":_vm.forEachSelectedFiltered,"individualFunction":[
      { function: _vm.copyOffer, class: 'md-round', icon: 'content_copy' } ],"highlightRows":_vm.highlightRows},on:{"checked":_vm.updateInvoiceCheck}}),(_vm.selectedOfferId !== null && _vm.loaded)?_c('OfferModal',{attrs:{"id":parseInt(_vm.selectedOfferId)},on:{"modal-hide":function($event){return _vm.modalHide()},"saved-offer":function($event){_vm.modalHide();
      _vm.getOffersOrOfferGroups();}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }